<template>
  <div class="hideVConsole">
    <p v-if="show">hideVConsole OK,reload Page</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false
    };
  },
  created() {
    window.localStorage.removeItem("showVConsole");
    this.show = true;
  }
};
</script>
